import { getAnalytics, logEvent } from 'firebase/analytics';
import app from './firebase';

// Initialize Firebase Analytics
let analytics = null;

try {
  analytics = getAnalytics(app);
} catch (e) {
  // Analytics may not be available in all environments (e.g., Capacitor native)
  console.log('Firebase Analytics not available:', e.message);
}

/**
 * Track funnel events for BabyBookin
 */

export const trackSignupComplete = (method = 'email') => {
  if (!analytics) return;
  logEvent(analytics, 'signup_complete', { method });
};

export const trackBookCreated = (bookId) => {
  if (!analytics) return;
  logEvent(analytics, 'book_created', { book_id: bookId });
};

export const trackPremiumPurchased = (source = 'upgrade_modal') => {
  if (!analytics) return;
  logEvent(analytics, 'premium_purchased', { source });
};

export const trackPrintOrderStarted = (bookId, pageCount) => {
  if (!analytics) return;
  logEvent(analytics, 'print_order_started', {
    book_id: bookId,
    page_count: pageCount
  });
};

export default analytics;
